import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { CreateClaimReversal } from './schema';

export const claimReversalCreateSchema = yup.object<
  ObjectType<CreateClaimReversal>
>({
  invoiceNumber: yup.string().required(),
});
